import React, { useState, useEffect, useContext, createContext } from 'react';
import MemberPersonalDetails from './personalDetails/memberPersonalDetails';
import MemberLandDetails from './landDetails/memberLandDetails';
import { GET_GROWER_BY_URN, UPDATE_GROWER, GET_STAKEHOLDER_BY_URN, ALLOCATE_WORKFLOW, INITIATE_WORKFLOW_FOR_REG_SCRU, CHECK_USER_DISTRICT_MAPPING } from '../../../../common/URLs'
import { API_DATE_FORMAT, CONSTANTS, GENDER, PROD, RESOURCE_ROLES, ROLES, SALUTATION } from '../../../../common/constants'
import jwt from 'jwt-decode';
import { useNavigate, useLocation } from "react-router-dom";
import { getLocalStorageItem } from '../../../../common/localStorageUtils';
import { toast } from 'react-toastify';
import { Button, Box, Typography, Grid, Stack, Container } from "@mui/material";
import BackButton from '../../../../common/backButton';
import { useTranslation } from "react-i18next";
import { VALIDATION, emailValidation, maxNameLength, urnMaxLength } from '../../../../common/commonValidations';
import moment from 'moment';
import { loaderService } from '../../../../common/custom-loader/loader-service';
import Preview from '../preview';
import { getAllComments, insertComment } from '../commonRegistrationStakeholderAPIs';
import { GetRecentCommentObject } from '../../../../common/commonFunction';
import { TextField } from '@mui/material';
import { PreviewIcon, SaveIcon } from '../../../../common/icons';
import _ from 'lodash';
import { appInsights } from '../../../../AppInsights';
import apiClient from '../../../../axios';
import BadgeComponent from '../../../../common/badge';

const GrowerMemberContext = createContext();

function RegistrationMemberDetails(props) {
  const { state } = useLocation();
  const urn = state?.URN ? state.URN : props.urn;
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [growerDetails, setGrowerDetails] = useState();
  const [updateGrowerResponse, setUpdateGrowerResponse] = useState();
  const [memberDetailArray, setMemberDetailArray] = useState([]);
  const [orgMemberDetailArray, setOrgMemberDetailArray] = useState([]);
  const decoded = jwt(getLocalStorageItem('id_token'));
  let userRole = localStorage.getItem('role');
  let uuid = localStorage.getItem('uuid');
  const bambooSpeciesRes = props.bambooSpeciesRes;
  const [expandedSection, setExpandedSection] = useState("personal");
  const [callUpdateApi, setCallUpdateApi] = useState(false);
  const [currentPage, setCurrentPage] = useState("registrationDetails");
  const [buttonAction, setButtonAction] = useState("");
  const [newLandArray, setNewLandArray] = useState([]);
  const [newLandComments, setNewLandComments] = useState([]);
  const [commentsData, setCommentsData] = useState();
  const [comments, setComments] = useState([]);
  const [showCommentSection, setShowCommentSection] = useState(false);
  const [regScruResourceUpdate, setRegScruResourceUpdate] = useState(false);
  const [stakeHolderDetails, setStakeHolderDetails] = useState();
  const [showWorkFlowButtons, setShowWorkFlowButtons] = useState(false);
  const [showClarificationButton, setShowClarificationButton] = useState(false);
  const [enableSaveSubmitButtons, setEnableSaveSubmitButtons] = useState(false);
  const [personalDetailsSectionOk, setPersonalDetailsSectionOk] = useState(false);
  const [bankDetailsSectionOk, setBankDetailsSectionOk] = useState(false);
  // const [bambooDetailsSectionOk, setBambooDetailsSectionOk] = useState(false);
  const [agreementDetailsSectionOk, setAgreementDetailsSectionOk] = useState(false);
  const [shouldActOnSection, setShouldActOnSection] = useState({
    personal_details: false,
    bank_details: false,
    agreement_details: false,
    // bamboo_details: false,
    jfmc_details: false
  })
  const [landDetailsSectionOk, setLandDetailsSectionOk] = useState({});
  const [shouldActOnSectionLand, setShouldActOnSectionLand] = useState({});
  const [callWorkFlowApi, setCallWorkFlowApi] = useState(false);
  const [personalUpdatedDetails, setPersonalUpdatedDetails] = useState({
    fullName: "",
    mobileNo: "",
    address: "",
    pincode: "",
    state: "",
    district: "",
    revenueCircle: "",
    blockName: "",
    govtIdCardType: CONSTANTS.ID_PROOF_ARRAY[0],
    govtIdCardNumber: "",
    otherGovtCardType: "",
    panNumber: null,
    bankAccountNumber: null,
    bankAccountHolderName: null,
    bankBranch: null,
    bankIfscCode: null,
    isOtpValidated: false,
    growerDocuments: [],
    contactPersonGender: GENDER[0],
    contactPersonSalutation: SALUTATION[0],
    contactPersonFirstname: '',
    contactPersonMiddlename: '',
    contactPersonLastname: '',
    growerType: '',
    stakeHolderSubCategory: '',
    isMSME: '',
    msmeCategory: '',
    agreementStartDate: moment(new Date()).format(API_DATE_FORMAT),
    agreementEndDate: moment(new Date()).format(API_DATE_FORMAT),
    plotTotalLandArea: "",
    landAreaValue: '',
    landAreaUnit: 'sq ft',
    availableLandAreaValue: '',
    availableLandAreaUnit: 'sq ft',
    addressError: '',
    pincodeError: '',
    stateError: '',
    districtError: '',
    subDivisionError: '',
    revenueCircleError: '',
    captiveError: '',
    captiveStartDateError: '',
    captiveEndDateError: '',
    landAreaError: '',
    availableLandAreaError: '',
    landLeasedOwnedError: '',
    leaseStartDateError: '',
    leaseEndDateError: '',
    landTypeError: '',
    easeOfSourcingError: '',
    sidingRequirementError: '',
    sidingDistanceInMtrsError: '',
    growerBambooSpeciesError: '',
    regGrowerMasterIdError: '',
    landNameError: '',
    memberContactError: '',
    longitudesError: '',
    latitudesError: '',
    documentError: '',
    landDocumentError: '',
    landPicError: '',
    memberlandDetailsError: '',
    memberNameError: ''
  });
  const [landUpdatedDetails, setLandUpdatedDetails] = useState(
    {
      address: '',
      pincode: '',
      state: '',
      district: '',
      subDivision: '',
      revenueCircle: '',
      blockName: '',
      captive: true,
      captiveStartDate: moment(new Date()).format(API_DATE_FORMAT),
      captiveEndDate: moment(new Date()).format(API_DATE_FORMAT),
      landArea: '',
      landAreaValue: '',
      landAreaUnit: 'sq ft',
      availableLandArea: '',
      availableLandAreaValue: '',
      availableLandAreaUnit: 'sq ft',
      landLeasedOwned: '',
      leaseStartDate: moment(new Date()).format(API_DATE_FORMAT),
      leaseEndDate: moment(new Date()).format(API_DATE_FORMAT),
      landType: '',
      easeOfSourcing: '',
      sidingRequirement: true,
      sidingDistanceInMtrs: '',
      growerCoopBambooSpecies: [],
      regGrowerMasterId: '',
      growerCoopLandDocuments: [],
      landName: '',
      geocodeLattitude: '',
      geocodeLongitude: '',
    }
  );
  const [errorMessage, setErrorMessage] = useState({
    contactPersonFirstNameError: '',
    accountNumberError: '',
    accountHolderNameError: '',
    ifscCodeError: '',
    addressError: '',
    OTPError: '',
    agreementStartDateError: '',
    agreementEndDateError: '',
    documentError: '',
    govtIdCardNumberError: '',
    otherCardError: '',
    panDocError: '',
    idProofDocError: '',
    bankDocError: '',
    agreementDocError: '',
    harvestPlanDocError: '',
    emailIdError: ''
  });

  useEffect(() => {
    if (urn) {
      getgrowerDetails();
      getStakeholderDetailsFromUrn();
    }
  }, [urn]);
  useEffect(() => {
    if (callUpdateApi) {
      appInsights.trackEvent({
        name: 'Details Changed',
        properties: {
          timeStamp: new Date().toISOString(),
          user: decoded.extension_URN ? decoded.extension_URN : localStorage.getItem('email')
        }
      })
      if (buttonAction === "submit" && userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal") {
        onCheckUserDistrictMapping();
      }
      else updateGrower();
      // updateGrower();
    }
  }, [callUpdateApi]);

  const onCheckUserDistrictMapping = () => {
    loaderService.showLoader();
    apiClient.post(CHECK_USER_DISTRICT_MAPPING,
      {
        "state": stakeHolderDetails?.growerMasters?.[0]?.state,
        "plotDistrict": stakeHolderDetails?.growerMasters?.[0]?.plotDistrict
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
      .then((response) => {
        if (response.data.isSuccess === true) {
          updateGrower();
        } else {
          toast.error(response.data?.message)
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();

      });
  };

  useEffect(() => {
    const loggedInUser = decoded.extension_URN ? stakeHolderDetails?.id : uuid
    setComments(commentsData);
    memberDetailArray.forEach(memberItem => {
      memberItem?.growerCoopLandDetails?.map((item) => {
        return (
          landDetailsSectionOk[`${item.id}`] = GetRecentCommentObject(commentsData?.filter((filterItem) => filterItem.sectionName === "land_details" && filterItem.sectionId === item.id))?.sectionOk ? GetRecentCommentObject(commentsData?.filter((filterItem) => filterItem.sectionName === "land_details" && filterItem.sectionId === item.id))?.sectionOk : false,
          shouldActOnSectionLand[`${item.id}`] = false
        )
      })
    })
    let personalCommentsInitial = commentsData?.filter((item) => item.sectionName === "personal_details");
    let bankCommentsInitial = commentsData?.filter((item) => item.sectionName === "bank_details");
    // let bambooCommentsInitial = commentsData?.filter((item) => item.sectionName === "bamboo_details");
    let agreementDetailsInitial = commentsData?.filter((item) => item.sectionName === "agreement_details");
    let jfmcDetailsInitial = commentsData?.filter((item) => item.sectionName === "jfmc_details");
    setPersonalDetailsSectionOk(GetRecentCommentObject(personalCommentsInitial)?.sectionOk ? GetRecentCommentObject(personalCommentsInitial)?.sectionOk : false);
    setBankDetailsSectionOk(GetRecentCommentObject(bankCommentsInitial)?.sectionOk ? GetRecentCommentObject(bankCommentsInitial)?.sectionOk : false);
    // setBambooDetailsSectionOk(GetRecentCommentObject(bambooCommentsInitial)?.sectionOk ? GetRecentCommentObject(bambooCommentsInitial)?.sectionOk : false);
    setAgreementDetailsSectionOk(GetRecentCommentObject(agreementDetailsInitial)?.sectionOk ? GetRecentCommentObject(agreementDetailsInitial)?.sectionOk : false);
    if (!enableSaveSubmitButtons && !showWorkFlowButtons && !showClarificationButton) {
      Object.keys(shouldActOnSection).forEach(key => {
        shouldActOnSection[key] = false;
      });
      Object.keys(shouldActOnSectionLand).forEach(key => {
        shouldActOnSectionLand[key] = false;
      });
    }
    else if (userRole === RESOURCE_ROLES.PlantSCMMember) {
      Object.keys(shouldActOnSection).forEach(key => {
        shouldActOnSection[key] = false;
      });
      Object.keys(shouldActOnSectionLand).forEach(key => {
        shouldActOnSectionLand[key] = true;
      });
    }
    else if (stakeHolderDetails?.scrutinyStatus === "Pending_Clarification" && stakeHolderDetails?.currentOwnerID === loggedInUser) {
      Object.keys(shouldActOnSection).forEach(key => {
        const section = commentsData?.find(obj => obj.sectionName === key && obj.isActive === 1);
        shouldActOnSection[key] = !section?.sectionOk;
      });
      Object.keys(shouldActOnSectionLand).forEach(key => {
        const section = commentsData?.find(obj => obj.sectionId === key && obj.isActive === 1);
        shouldActOnSectionLand[key] = !section?.sectionOk;
      });
    }
    else {
      Object.keys(shouldActOnSection).forEach(key => {
        shouldActOnSection[key] = true;
      });
      Object.keys(shouldActOnSectionLand).forEach(key => {
        shouldActOnSectionLand[key] = true;
      });
    }
  }, [commentsData]);

  const [memberDetails, setMemberDetails] = useState({
    contact: '',
    name: '',
    growerCoopLandDetails: [],
    isActive: 1
  });

  const onAddNewMemberDetails = (memberDetailsData) => {
    const tempArr = [...memberDetailArray]
    // Get the highest position among members that have it
    const maxSequence = tempArr
      .filter(member => typeof member.sequence === 'number')
      .reduce((max, member) => Math.max(max, member.sequence), 0);
    if (memberDetailArray.length == 0 || memberDetailArray.filter((item) => item.contact == memberDetailsData.contact).length == 0 && memberDetailsData.name.length > 0 && memberDetailsData.contact.length > 0) {
      tempArr.push({ name: memberDetailsData.name, contact: memberDetailsData.contact, growerCoopLandDetails: [], isActive: 1, sequence: maxSequence + 1 });
      setMemberDetailArray(tempArr);
    }
    setMemberDetails(null);
  }
  const onEditMemberDetailsCallback = (selectedMember) => {
    const upadtedMember = (memberDetailArray.map((item, index) => {
      if (item.contact === selectedMember.contact) {
        item.name = selectedMember.name
      }
      return item
    }
    ))
    setMemberDetailArray(upadtedMember);
  }

  function getgrowerDetails() {
    loaderService.showLoader();
    apiClient
      .post(GET_GROWER_BY_URN,
        {
          "urn": urn,
          "type": "grower",
          "isScrutinyView": "true"
        },
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }, null
      )
      .then((response) => {
        loaderService.hideLoader();
        let growerDetailsLocal = response.data
        setGrowerDetails(response.data);
        if (growerDetailsLocal) {
          // Filter members without a sequence
          var memberArray = [...growerDetailsLocal?.growers[0]?.growerMemberDetails]
          const withOutSequence = memberArray
            ?.filter(member => !member.sequence)
            ?.sort((a, b) => new Date(a.createdOn) - new Date(b.createdOn))

          var count = memberArray.length;
          if (withOutSequence?.length == 0) {
            var sortedArray = memberArray?.sort((a, b) => b?.sequence - a?.sequence);
            sortedArray?.forEach((member) => {
              member.sequence = count;
              count--;
            });
            memberArray = sortedArray;
          }
          withOutSequence?.forEach((member, index) => {
            member.sequence = index + 1;
          });
          setMemberDetailArray(withOutSequence?.length == 0 ? memberArray : withOutSequence)
          setOrgMemberDetailArray(structuredClone(withOutSequence?.length == 0 ? memberArray : withOutSequence));
          newLandComments.map((item) => {
            const { type, id, landName, createdByName, createdOnFormatted, workflowStepDetailsId, ...commentObject } = item
            const findMemberItem = growerDetailsLocal.growers[0].growerMemberDetails.find((findMemItem) => findMemItem.growerCoopLandDetails.some((landItem) => landItem.landName === item.landName))
            const findItem = findMemberItem.growerCoopLandDetails.find((findItem) => findItem.landName === item.landName)
            if (findItem) {
              item.sectionId = findItem.id
            }
            return commentObject
          })
          newLandComments.length > 0 ? insertComment(newLandComments, growerDetailsLocal?.growers[0]?.regStakeholderMasterId, setCommentsData) : getAllComments(growerDetailsLocal?.growers[0]?.regStakeholderMasterId, setCommentsData)
          setNewLandComments([])
        }
      })
      .catch(function (error) {
        loaderService.hideLoader();
        console.log(error);
      });
  }

  const getStakeholderDetailsFromUrn = () => {
    loaderService.showLoader();
    apiClient.post(GET_STAKEHOLDER_BY_URN,
      {
        "urn": urn,
        "includeRejected": true
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
      .then((response) => {
        loaderService.hideLoader();
        let stakeHolderDetailsLocal = response.data.stakeHolder;
        setStakeHolderDetails(response.data.stakeHolder);
        if (stakeHolderDetailsLocal) {
          const loggedInUser = decoded.extension_URN ? stakeHolderDetailsLocal?.id : uuid

          if (stakeHolderDetailsLocal?.registrationStatus === "Scrutiny_Initiated" && stakeHolderDetailsLocal?.scrutinyStatus !== "Approved" && stakeHolderDetailsLocal?.scrutinyStatus !== "Rejected"
            &&
            (userRole === ROLES.RegistrationScruitnizer || decoded.extension_URN || userRole === ROLES.RegInCharge || userRole === ROLES.LeadRegScrutinizer || userRole === ROLES.RegSuperVisor)) {
            setShowCommentSection(true); //to show the comment section
          }
          if ((stakeHolderDetailsLocal?.scrutinyStatus === "Approved" || stakeHolderDetailsLocal?.registrationStatus === "ResourceUpdate_Initiated") && (userRole === ROLES.RegistrationScruitnizer && state?.userType === "Internal")) {
            setShowCommentSection(true);
            setRegScruResourceUpdate(true);
          }
          if (stakeHolderDetailsLocal?.scrutinyStatus !== "Rejected") {
            if (userRole === ROLES.ItAdmin || userRole === RESOURCE_ROLES.PlantSCMMember
              || (decoded.extension_URN && (stakeHolderDetailsLocal?.scrutinyStatus === "Approved" || (!stakeHolderDetailsLocal?.registrationCompleted && stakeHolderDetailsLocal?.registrationStatus !== "Scrutiny_Initiated")))
              || (userRole === ROLES.RegistrationScruitnizer && stakeHolderDetailsLocal?.registrationStatus === "Scrutiny_Initiated") || (userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal" && stakeHolderDetailsLocal?.scrutinyStatus === "Approved")) {
              setEnableSaveSubmitButtons(true);
            }
          }
          if (stakeHolderDetailsLocal?.registrationCompleted && stakeHolderDetailsLocal?.currentOwnerID === loggedInUser && stakeHolderDetailsLocal?.scrutinyStatus !== "Approved" && stakeHolderDetailsLocal?.scrutinyStatus !== "Rejected") {
            // && state?.registerByScruOtpValidated for otp validation in pending clarification add after userole in below line
            if (((userRole === ROLES.RegistrationScruitnizer) || decoded.extension_URN) && stakeHolderDetailsLocal?.scrutinyStatus == "Pending_Clarification") {
              setShowClarificationButton(true);
              setEnableSaveSubmitButtons(true);
            }
            if (userRole === ROLES.RegInCharge || userRole === ROLES.LeadRegScrutinizer || (userRole === ROLES.RegistrationScruitnizer && stakeHolderDetailsLocal?.scrutinyStatus != "Pending_Clarification")) {
              setShowWorkFlowButtons(true);
            }
          }
        }
      })
      .catch(function (error) {
        loaderService.hideLoader();
        console.log(error);
      });

  }

  const getRegistrationStatus = () => {
    const grower = growerDetails?.growers[0];
    const regStakeholderMaster = grower?.regStakeholderMaster;
    var regStatus = regStakeholderMaster?.registrationStatus;
    if (userRole != ROLES.ItAdmin) {
      if (regStakeholderMaster?.registrationStatus === "Approved" && (userRole === RESOURCE_ROLES.PlantSCMMember || (userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal"))) {
        regStatus = "ResourceUpdate_Initiated";
      }
    }
    return regStatus;
  }
  const getSubmit = () => {
    if (userRole !== ROLES.ItAdmin && buttonAction === "submit") {
      return true
    }
    else {
      return false
    }
  }

  const enableFieldFunction = (sectionEnabled, isPreg, isNew, isLatLon) => {
    if (state?.viewOnly) {
      return false
    }
    if (isLatLon && localStorage.getItem('role') === ROLES.RegistrationScruitnizer && stakeHolderDetails?.currentOwnerID === uuid) {
      return true
    }
    if (userRole === ROLES.ItAdmin) {
      return true
    }
    if (
      userRole === ROLES.RegistrationScruitnizer &&
      state?.userType === "Internal"
    ) { return true; }
    else if (enableSaveSubmitButtons && sectionEnabled && !isPreg) {
      if (stakeHolderDetails?.scrutinyStatus !== "Pending_Clarification" && !isLatLon && stakeHolderDetails?.registrationCompleted && stakeHolderDetails?.scrutinyStatus !== "Approved") {
        return false
      }
      else return true
    }
    else if (isNew) {
      return true
    }
    else return false
  }


  const grower = growerDetails?.growers[0];
  const regStakeholderMaster = grower?.regStakeholderMaster;

  const initialData = {
    "id": regStakeholderMaster?.id,
    "name": regStakeholderMaster?.name,
    "contactPersonName": regStakeholderMaster?.contactPersonName,
    "contactPersonFirstname": regStakeholderMaster?.contactPersonFirstname,
    "contactPersonMiddlename": regStakeholderMaster?.contactPersonMiddlename,
    "contactPersonLastname": regStakeholderMaster?.contactPersonLastname,
    "contactPersonGender": regStakeholderMaster?.contactPersonGender,
    "contactPersonSalutation": regStakeholderMaster?.contactPersonSalutation,
    "mobileNo": regStakeholderMaster?.mobileNo,
    "isOtpValidated": regStakeholderMaster?.isOtpValidated,
    "bankAccountNumber": regStakeholderMaster?.bankAccountNumber,
    "bankAccountHolderName": regStakeholderMaster?.bankAccountHolderName,
    "bankBranch": regStakeholderMaster?.bankBranch,
    "bankIfscCode": regStakeholderMaster?.bankIfscCode,
    "bankName": regStakeholderMaster?.bankName,
    "panNumber": regStakeholderMaster?.panNumber,
    "govtIdCardType": regStakeholderMaster?.govtIdCardType,
    "govtIdCardNumber": regStakeholderMaster?.govtIdCardNumber,
    "otherGovtCardType": regStakeholderMaster?.otherGovtCardType,
    "emailId": regStakeholderMaster?.emailId,
    "category": regStakeholderMaster?.category,
    "stakeHolderType": regStakeholderMaster?.stakeHolderType,
    "urn": regStakeholderMaster?.urn,
    "preRegistrationShortlisted": regStakeholderMaster?.preRegistrationShortlisted,
    "registrationStatus": regStakeholderMaster?.registrationStatus,
    "scrutinyStatus": regStakeholderMaster?.scrutinyStatus,
    "stakeholderStatus": regStakeholderMaster?.stakeholderStatus,
    "createdOn": regStakeholderMaster?.createdOn,
    "createdBy": regStakeholderMaster?.createdBy,
    "updatedOn": regStakeholderMaster?.updatedOn,
    "updatedBy": regStakeholderMaster?.updatedBy,
    "isActive": regStakeholderMaster?.isActive,
    "acceptedTerms": regStakeholderMaster?.acceptedTerms,
    "isMSME": regStakeholderMaster?.isMSME,
    "msmeCategory": regStakeholderMaster?.msmeCategory,
    "growerDetails": [
      {
        "id": grower?.id,
        "regStakeholderMasterId": grower?.regStakeholderMasterId,
        "growerCategory": grower?.growerCategory,
        "growerType": grower?.growerType,
        "authorizedContactPerson": grower?.authorizedContactPerson,
        "address": grower?.address,
        "pincode": grower?.pincode,
        "state": grower?.state,
        "district": grower?.district,
        "revenueCircle": grower?.revenueCircle,
        "blockName": grower?.blockName,
        "expansionPlan": grower?.expansionPlan,
        "aggregationPoint": grower?.aggregationPoint,
        "aggregationPointName": grower?.aggregationPointName,
        "aggregationPointContact": grower?.aggregationPointContact,
        "aggregationPointPincode": grower?.aggregationPointPincode,
        "aggregationPointAddress": grower?.aggregationPointAddress,
        "aggregationPointState": grower?.aggregationPointState,
        "aggregationPointDistrict": grower?.aggregationPointDistrict,
        "aggregationPointSubDivision": grower?.aggregationPointSubDivision,
        "aggregationPointPostOffice": grower?.aggregationPointPostOffice,
        "readyToHarvest": grower?.readyToHarvest,
        "locationGeocode": grower?.locationGeocode,
        "documentId": grower?.documentId,
        "divisionalForestOfficeName": grower?.documentId,
        "divisionalForestOfficeAddress": grower?.divisionalForestOfficeAddress,
        "divisionalForestOfficeContactName": grower?.divisionalForestOfficeContactName,
        "divisionalForestOfficeContactNo": grower?.divisionalForestOfficeContactNo,
        "forestDeptPincode": grower?.forestDeptPincode,
        "forestDeptState": grower?.forestDeptState,
        "forestDeptDistrict": grower?.forestDeptDistrict,
        "forestDeptSubDivision": grower?.forestDeptSubDivision,
        "forestDeptPostOffice": grower?.forestDeptPostOffice,
        "forestDeptTotalLandArea": grower?.forestDeptTotalLandArea,
        "forestDeptTotalNoOfBambooClumps": grower?.forestDeptTotalNoOfBambooClumps,
        "forestRangeOfficeName": grower?.forestRangeOfficeName,
        "forestRangeOfficeAddress": grower?.forestRangeOfficeAddress,
        "forestRangeOfficeContactName": grower?.forestRangeOfficeContactName,
        "forestRangeOfficeContactNo": grower?.forestRangeOfficeContactNo,
        "forestRangeBeatName": grower?.forestRangeBeatName,
        "forestRangeBeatAddress": grower?.forestRangeBeatAddress,
        "forestRangeBeatContactName": grower?.forestRangeBeatContactName,
        "forestRangeBeatContactNo": grower?.forestRangeBeatContactNo,
        "agreementStartDate": grower?.agreementStartDate,
        "agreementEndDate": grower?.agreementEndDate,
        "plotAddress": grower?.plotAddress,
        "plotPincode": grower?.plotPincode,
        "plotState": grower?.plotState,
        "plotDistrict": grower?.plotDistrict,
        "plotSubDivision": grower?.plotSubDivision,
        "plotRevenueCircle": grower?.plotRevenueCircle,
        "plotBlockName": grower?.plotBlockName,
        "plotPostOffice": grower?.plotPostOffice,
        "plotTotalLandArea": grower?.plotTotalLandArea,
        "plotTotalNoOfBambooClumps": grower?.plotTotalNoOfBambooClumps,
        "cooperativeName": grower?.cooperativeName,
        "cooperativeContact": grower?.cooperativeContact,
        "royaltyCharge": grower?.royaltyCharge,
        "anyOtherFee": grower?.anyOtherFee,
        "createdOn": grower?.createdOn,
        "createdBy": grower?.createdBy,
        "updatedOn": grower?.updatedOn,
        "updatedBy": grower?.updatedBy,
        "isActive": grower?.isActive,
        "growerForestRangeDetails": [],
        "growerLandDetails": [],
        "growerDocuments": grower?.growerDocuments,
        "growerMemberDetails": orgMemberDetailArray,
      }
    ]
  }

  const isMSMENo =
    personalUpdatedDetails?.isMSME === 0 ||
    personalUpdatedDetails?.isMSME === "NO";


  const filteredGrowerDocuments = personalUpdatedDetails?.growerDocuments?.map(doc => {
    if (doc.documentType === "MSME_Certificate") {
      return {
        ...doc,
        isActive: isMSMENo ? 0 : 1
      };
    }
    return doc;
  });


  const finalData = {
    "id": regStakeholderMaster?.id,
    "name": personalUpdatedDetails?.fullName,
    "contactPersonName": personalUpdatedDetails?.contactPersonName,
    "contactPersonFirstname": personalUpdatedDetails?.contactPersonFirstname,
    "contactPersonMiddlename": personalUpdatedDetails?.contactPersonMiddlename,
    "contactPersonLastname": personalUpdatedDetails?.contactPersonLastname,
    "contactPersonGender": personalUpdatedDetails?.contactPersonGender,
    "contactPersonSalutation": personalUpdatedDetails?.contactPersonSalutation,
    "mobileNo": personalUpdatedDetails?.mobileNo,
    "isOtpValidated": personalUpdatedDetails?.isOtpValidated,
    "bankAccountNumber": personalUpdatedDetails?.bankAccountNumber,
    "bankAccountHolderName": personalUpdatedDetails?.bankAccountHolderName,
    "bankBranch": personalUpdatedDetails?.bankBranch,
    "bankIfscCode": personalUpdatedDetails?.bankIfscCode,
    "bankName": personalUpdatedDetails?.bankName,
    "panNumber": personalUpdatedDetails?.panNumber,
    "govtIdCardType": personalUpdatedDetails?.govtIdCardType,
    "govtIdCardNumber": personalUpdatedDetails?.govtIdCardNumber,
    "otherGovtCardType": personalUpdatedDetails?.otherGovtCardType,
    "emailId": personalUpdatedDetails?.emailId,
    "category": regStakeholderMaster?.category,
    "stakeHolderType": regStakeholderMaster?.stakeHolderType,
    "urn": regStakeholderMaster?.urn,
    "preRegistrationShortlisted": regStakeholderMaster?.preRegistrationShortlisted,
    "registrationStatus": getRegistrationStatus(),
    "scrutinyStatus": regStakeholderMaster?.scrutinyStatus,
    "stakeholderStatus": regStakeholderMaster?.stakeholderStatus,
    "createdOn": regStakeholderMaster?.createdOn,
    "createdBy": regStakeholderMaster?.createdBy,
    "updatedOn": regStakeholderMaster?.updatedOn,
    "updatedBy": regStakeholderMaster?.updatedBy,
    "isActive": regStakeholderMaster?.isActive,
    "acceptedTerms": regStakeholderMaster?.acceptedTerms,
    "isMSME": personalUpdatedDetails?.isMSME,
    "msmeCategory": personalUpdatedDetails?.msmeCategory,
    "growerDetails": [
      {
        "id": grower?.id,
        "regStakeholderMasterId": grower?.regStakeholderMasterId,
        "growerCategory": grower?.growerCategory,
        "growerType": personalUpdatedDetails?.growerType,
        "authorizedContactPerson": grower?.authorizedContactPerson,
        "address": personalUpdatedDetails?.address,
        "pincode": personalUpdatedDetails?.pincode,
        "state": personalUpdatedDetails?.state,
        "district": personalUpdatedDetails?.district,
        "revenueCircle": personalUpdatedDetails?.revenueCircle,
        "blockName": personalUpdatedDetails?.blockName,
        "expansionPlan": grower?.expansionPlan,
        "aggregationPoint": personalUpdatedDetails?.aggregationPoint,
        "aggregationPointName": personalUpdatedDetails?.aggregationPointName,
        "aggregationPointContact": personalUpdatedDetails?.aggregationPointContact,
        "aggregationPointPincode": personalUpdatedDetails?.aggregationPointPincode,
        "aggregationPointAddress": personalUpdatedDetails?.aggregationPointAddress,
        "aggregationPointState": personalUpdatedDetails?.aggregationPointState,
        "aggregationPointDistrict": personalUpdatedDetails?.aggregationPointDistrict,
        "aggregationPointSubDivision": personalUpdatedDetails?.aggregationPointSubDivision,
        "aggregationPointPostOffice": personalUpdatedDetails?.aggregationPointPostOffice,
        "readyToHarvest": grower?.readyToHarvest,
        "locationGeocode": personalUpdatedDetails?.locationGeocode,
        "documentId": grower?.documentId,
        "divisionalForestOfficeName": grower?.documentId,
        "divisionalForestOfficeAddress": grower?.divisionalForestOfficeAddress,
        "divisionalForestOfficeContactName": grower?.divisionalForestOfficeContactName,
        "divisionalForestOfficeContactNo": grower?.divisionalForestOfficeContactNo,
        "forestDeptPincode": grower?.forestDeptPincode,
        "forestDeptState": grower?.forestDeptState,
        "forestDeptDistrict": grower?.forestDeptDistrict,
        "forestDeptSubDivision": grower?.forestDeptSubDivision,
        "forestDeptPostOffice": grower?.forestDeptPostOffice,
        "forestDeptTotalLandArea": grower?.forestDeptTotalLandArea,
        "forestDeptTotalNoOfBambooClumps": grower?.forestDeptTotalNoOfBambooClumps,
        "forestRangeOfficeName": grower?.forestRangeOfficeName,
        "forestRangeOfficeAddress": grower?.forestRangeOfficeAddress,
        "forestRangeOfficeContactName": grower?.forestRangeOfficeContactName,
        "forestRangeOfficeContactNo": grower?.forestRangeOfficeContactNo,
        "forestRangeBeatName": grower?.forestRangeBeatName,
        "forestRangeBeatAddress": grower?.forestRangeBeatAddress,
        "forestRangeBeatContactName": grower?.forestRangeBeatContactName,
        "forestRangeBeatContactNo": grower?.forestRangeBeatContactNo,
        "agreementStartDate": personalUpdatedDetails?.agreementStartDate,
        "agreementEndDate": personalUpdatedDetails?.agreementEndDate,
        "plotAddress": personalUpdatedDetails?.plotAddress,
        "plotPincode": personalUpdatedDetails?.plotPincode,
        "plotState": personalUpdatedDetails?.plotState,
        "plotDistrict": personalUpdatedDetails?.plotDistrict,
        "plotSubDivision": personalUpdatedDetails?.plotSubDivision,
        "plotRevenueCircle": personalUpdatedDetails?.plotRevenueCircle,
        "plotBlockName": personalUpdatedDetails?.plotBlockName,
        "plotPostOffice": personalUpdatedDetails?.plotPostOffice,
        "plotTotalLandArea": personalUpdatedDetails?.plotTotalLandArea,
        "plotTotalNoOfBambooClumps": personalUpdatedDetails?.plotTotalNoOfBambooClumps,
        "cooperativeName": grower?.cooperativeName,
        "cooperativeContact": grower?.cooperativeContact,
        "royaltyCharge": grower?.royaltyCharge,
        "anyOtherFee": grower?.anyOtherFee,
        "createdOn": grower?.createdOn,
        "createdBy": grower?.createdBy,
        "updatedOn": grower?.updatedOn,
        "updatedBy": grower?.updatedBy,
        "isActive": grower?.isActive,
        "growerForestRangeDetails": [],
        "growerLandDetails": [],
        "growerDocuments": filteredGrowerDocuments,
        "growerMemberDetails": memberDetailArray
      }
    ]
  }

  // console.log("data1", initialData?.growerDetails[0]?.growerMemberDetails)
  // console.log("data2", finalData?.growerDetails[0]?.growerMemberDetails)

  function updateGrower(updateGrowerCallBack) {
    loaderService.showLoader();
    apiClient
      .post(UPDATE_GROWER + `?IsRegistrationSubmit=${getSubmit()}`,
        finalData,
        {
          headers: {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
          }
        }
      )
      .then((response) => {
        loaderService.hideLoader();
        const updateGrowerResponse = response?.data
        setCallUpdateApi(false);
        if (updateGrowerResponse?.isSuccess) {
          getgrowerDetails();
          if (buttonAction === "preview") {
            setCurrentPage("preview")
          }
          if (buttonAction === "submit" || buttonAction === "save") {
            toast.success(updateGrowerResponse?.message);
          }
          if (buttonAction === "submit" && userRole === ROLES?.RegistrationScruitnizer && state?.userType === "Internal" && stakeHolderDetails?.scrutinyStatus === "Approved") {
            onSubmit();
          }
          if (buttonAction === "submit") {
            if (decoded.extension_URN) {
              navigate('/dashboardHome/dashboardStakeHolder');
            }
            else if (userRole === RESOURCE_ROLES.PlantSCMMember) {
              navigate('/resourcedashboard/searchByURN');
            }
            else if (userRole === ROLES.ItAdmin) {
              navigate('/sidebar/viewAllActiveApplications');
            }
            else if (userRole === ROLES.RegistrationScruitnizer && state?.userType === "Internal") {
              navigate('/registrationHome/dashboard');
            }
            else if (userRole === ROLES.RegistrationScruitnizer) {
              setCallWorkFlowApi(true);
            }
            else {
              navigate(-1);
            }
          }
        }
        else {
          toast.error(updateGrowerResponse?.message);
          setCurrentPage("registrationDetails")
        }
      })
      .catch(function (error) {
        loaderService.hideLoader();
        console.log(error);
      });
  }

  const onSubmit = () => {
    loaderService.showLoader();
    apiClient.post(INITIATE_WORKFLOW_FOR_REG_SCRU,
      {
        "stakeholderMappings": [
          {
            "scrutinizerId": getLocalStorageItem('uuid'),
            "stakeholderID": stakeHolderDetails?.id,
            "stakeholderState": stakeHolderDetails?.growerMasters?.[0]?.state,
            "stakeholderDistrict": stakeHolderDetails?.growerMasters?.[0]?.district,
            "loggedInUserID": getLocalStorageItem('uuid'),
            "isActive": 1,
            // "leadScrutinizerID": "3fa85f64-5717-4562-b3fc-2c963f66afa6"
          }
        ]
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
      .then((response) => {
        if (response.data.isSuccess === true) {
          onActionWorflowSubmit();
        } else {
          toast.error(response.data?.message)
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();

      });
  };

  const onActionWorflowSubmit = () => {
    loaderService.showLoader();
    apiClient.post(ALLOCATE_WORKFLOW,
      {
        "stakeHolderMasterID": stakeHolderDetails?.id,
        "workflowInitiatorID": getLocalStorageItem('uuid'),
        "workflowReceiverID": "",
        "workflowAction": "Approve",
        "status": "",
        "isStakeHolderAction": false,
        "workflowInitiatorRole": localStorage.getItem('role'),
      },
      {
        headers: {
          Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
      }, null
    )
      .then((response) => {
        if (response.data.isSuccess === true) {
          toast.success(response.data?.message);
          if (localStorage.getItem('uuid'))
            navigate('/registrationHome/dashboard');
          else
            navigate('/dashboardHome/dashboardStakeHolder');
        } else {
          toast.error(response.data?.message)
        }
        loaderService.hideLoader();
      })
      .catch(function (error) {
        console.log(error);
        loaderService.hideLoader();

      });
  };

  const noCommentForMandatorySections = () => {
    if (stakeHolderDetails?.scrutinyStatus == "Submited_Clarification") {
      if (comments.find((item) => item.sectionName === "personal_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "personal_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("personal");
        setErrorMessage({ ...errorMessage, personalCommentError: "Please enter comment and save" });
        // toast.error("Please enter comment and save");
        return true;
      }
      if (comments.find((item) => item.sectionName === "bank_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "bank_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("bank");
        setErrorMessage({ ...errorMessage, bankCommentError: "Please enter comment and save" });
        // toast.error("Please enter comment and save");
        return true;
      }
      if (comments.find((item) => item.sectionName === "agreement_details" && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !comments.find((item) => item.sectionName === "agreement_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("agreement");
        setErrorMessage({ ...errorMessage, agreementCommentError: "Please enter comment and save" });
        // toast.error("Please enter comment and save");
        return true;
      }
    }
    else {
      if (shouldActOnSection.personal_details && !comments.find((item) => item.sectionName === "personal_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("personal");
        setErrorMessage({ ...errorMessage, personalCommentError: "Please enter comment and save" });
        // toast.error("Please enter comment and save");
        return true;
      }
      if (shouldActOnSection.bank_details && !comments.find((item) => item.sectionName === "bank_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("bank");
        setErrorMessage({ ...errorMessage, bankCommentError: "Please enter comment and save" });
        // toast.error("Please enter comment and save");
        return true;
      }
      if (shouldActOnSection.agreement_details && !comments.find((item) => item.sectionName === "agreement_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)) {
        setExpandedSection("agreement");
        setErrorMessage({ ...errorMessage, agreementCommentError: "Please enter comment and save" });
        // toast.error("Please enter comment and save");
        return true;
      }
    }
    return false
  }

  const personalDetailsValidation = () => {
    var idProof = personalUpdatedDetails?.growerDocuments && personalUpdatedDetails?.growerDocuments.filter((item) => item.documentType === "MOA_RegistrationCertificate" && (item.isActive == 1 || item.isActive == 3));
    var panDoc = personalUpdatedDetails?.growerDocuments && personalUpdatedDetails?.growerDocuments.filter((item) => item.documentType === "PANCard" && (item.isActive == 1 || item.isActive == 3));
    if (!personalUpdatedDetails.fullName || personalUpdatedDetails.fullName.length == 0) {
      setErrorMessage({ fullNameError: "Please enter name" });
      toast.error("Please enter name");
      setExpandedSection("personal");
      return;
    }
    else if (!personalUpdatedDetails.contactPersonFirstname || personalUpdatedDetails.contactPersonFirstname.length == 0) {
      setErrorMessage({ contactPersonFirstNameError: "Please enter contact person name" });
      toast.error("Please enter contact person name");
      setExpandedSection("personal");
      return;
    }
    else if (!personalUpdatedDetails.address || personalUpdatedDetails.address.length == 0) {
      setErrorMessage({ addressError: "Please enter address" });
      toast.error("Please enter address");
      setExpandedSection("personal");
      return;
    }
    else if (personalUpdatedDetails.pincode && personalUpdatedDetails.pincode.length !== 6) {
      setErrorMessage({ pincodeError: "Please enter a valid pincode" });
      toast.error("Please enter a valid pincode");
      setExpandedSection("personal");
      return;
    }
    if (!personalUpdatedDetails.state || personalUpdatedDetails.state.length == 0) {
      setErrorMessage({ searchError: "Please search pincode" });
      toast.error("Please search pincode");
      setExpandedSection("personal");
      return;
    }
    else if (!personalUpdatedDetails.emailId || personalUpdatedDetails.emailId.length == 0) {
      setErrorMessage({ ...errorMessage, emailIdError: "Please enter Email Address" });
      toast.error("Please enter Email Address");
      setExpandedSection("personal");
      return;
    }
    else if (personalUpdatedDetails.emailId.length > 0 && !emailValidation(personalUpdatedDetails.emailId.slice(0, 50))) {
      setErrorMessage({ ...errorMessage, emailIdError: "Please enter valid Email Address" });
      toast.error("Please enter valid Email Address");
      setExpandedSection("personal");
      return;
    }

    if (userRole !== ROLES.ItAdmin) {
      if (!personalUpdatedDetails.panNumber || personalUpdatedDetails.panNumber.length == 0) {
        setErrorMessage({ ...errorMessage, panNumberError: "Please enter PAN Number" });
        toast.error("Please enter PAN Number");
        setExpandedSection("personal");
        return;
      }
      else if (personalUpdatedDetails.panNumber && personalUpdatedDetails.panNumber.length > 0 && !VALIDATION.panNumberValidation(personalUpdatedDetails.panNumber)) {
        setErrorMessage({ ...errorMessage, panNumberError: "Please enter valid PAN Number" });
        toast.error("Please enter valid PAN Number");
        setExpandedSection("personal");
        return;
      }
      else if (panDoc.length == 0) {
        setErrorMessage({ panDocError: "Please upload PAN document" });
        toast.error("Please upload PAN document");
        setExpandedSection("personal");
        return;
      }
      else if (!personalUpdatedDetails.govtIdCardNumber || personalUpdatedDetails.govtIdCardNumber.length == 0) {
        setErrorMessage({ govtIdCardNumberError: "Please enter ID Number" });
        toast.error("Please enter ID Number");
        setExpandedSection("personal");
        return;
      }
      else if (personalUpdatedDetails.govtIdCardType == "GST" && !VALIDATION.gstNumberValidation(personalUpdatedDetails.govtIdCardNumber)) {
        setErrorMessage({ govtIdCardNumberError: "Please enter valid GST No." });
        toast.error("Please enter valid GST No.");
        return;
      }
      else if (idProof.length == 0) {
        setErrorMessage({ idProofDocError: "Please upload ID Proof document" });
        toast.error("Please upload ID Proof document");
        setExpandedSection("personal");
        return;
      }
      else if (personalUpdatedDetails.isMSME === 1) {

        if (!personalUpdatedDetails.msmeCategory) {
          toast.error("Please select MSME category");
          setExpandedSection("personal");
          return;
        }

        const msmeDoc =
          personalUpdatedDetails?.growerDocuments &&
          personalUpdatedDetails.growerDocuments.filter(
            (item) =>
              item.documentType === "MSME_Certificate" &&
              (item.isActive === 1 || item.isActive === 3)
          );

        if (!msmeDoc || msmeDoc.length === 0) {
          setErrorMessage({
            ...errorMessage,
            msmeDocError: "Please upload MSME certificate"
          });
          toast.error("Please upload MSME certificate");
          setExpandedSection("personal");
          return;
        }
      }

      bankDetailsValidations();
    }
    else showPreview();

    const checkValidations = (e) => {

      //else if (!personalUpdatedDetails.agreementStartDate || personalUpdatedDetails.agreementStartDate.length == 0) {
      //  setErrorMessage({ agreementStartDateError: "Please enter agreement start date" })
      //  return;
      //}
      //else if (!personalUpdatedDetails.agreementEndDate || personalUpdatedDetails.agreementEndDate.length == 0) {
      //  setErrorMessage({ agreementEndDateError: "Please enter agreement end date" })
      //  return;
      //}

      if (personalUpdatedDetails.panNumber && personalUpdatedDetails.panNumber.length > 0 && !VALIDATION.panNumberValidation(personalUpdatedDetails.panNumber)) {
        setErrorMessage({ ...errorMessage, panNumberError: "Please enter valid PAN Number" });
        return;
      }
    }
    // bankDetailsValidations();
  }

  const bankDetailsValidations = () => {
    var bankdoc = personalUpdatedDetails?.growerDocuments && personalUpdatedDetails?.growerDocuments.filter((item) => item.documentType === "BankPassBook_CancelledCheque" && (item.isActive == 1 || item.isActive == 3));

    if (!personalUpdatedDetails.bankAccountNumber || personalUpdatedDetails.bankAccountNumber.length == 0 || !VALIDATION.bankAccountNumberValidation(personalUpdatedDetails.bankAccountNumber)) {
      setErrorMessage({ accountNumberError: "Please enter valid Account Number" });
      setExpandedSection("bank");
      toast.error("Please enter valid Account Number");
      return;
    }
    else if (!personalUpdatedDetails.bankAccountHolderName || personalUpdatedDetails.bankAccountHolderName.length == 0 || !VALIDATION.bankAccountNameValidation(personalUpdatedDetails.bankAccountHolderName)) {
      setErrorMessage({ accountHolderNameError: "Please enter Account Holder's Name" });
      setExpandedSection("bank");
      toast.error("Please enter Account Holder's Name");
      return;
    }
    else if (!personalUpdatedDetails.bankIfscCode || personalUpdatedDetails.bankIfscCode.length == 0 || !VALIDATION.ifscValidation(personalUpdatedDetails.bankIfscCode)) {
      setErrorMessage({ ifscCodeError: "Please enter valid IFSC code" });
      setExpandedSection("bank");
      toast.error("Please enter valid IFSC code");
      return;
    }
    else if (!personalUpdatedDetails.bankBranch || personalUpdatedDetails.bankBranch.length == 0) {
      setErrorMessage({ ifscCodeError: "Please enter valid IFSC code and search" });
      setExpandedSection("bank");
      toast.error("Please enter valid IFSC code and search");
      return;
    }
    else if (bankdoc.length == 0) {
      setErrorMessage({ bankDocError: "Please upload bank document" });
      setExpandedSection("bank");
      toast.error("Please upload bank document");
      return;
    }
    agreementDetailsValidations();
  }

  const agreementDetailsValidations = () => {
    if (personalUpdatedDetails.agreementStartDate > personalUpdatedDetails.agreementEndDate) {
      setErrorMessage({ agreementEndDateError: "Agreement end date can not be less than agreement start date" });
      setExpandedSection("agreement");
      toast.error("Agreement end date can not be less than agreement start date");
      return;
    }
    //var agreement = personalUpdatedDetails?.growerDocuments && personalUpdatedDetails?.growerDocuments.filter((item) => item.documentType === "LOI_ABRPLAgreement" && item.isActive == 1);
    //if (agreement.length == 0) {
    //  setErrorMessage({ agreementDocError: "Please upload LOI and agreement document" });
    //  setExpandedSection("agreement");
    //  return;
    //}
    //var harvest = personalUpdatedDetails?.growerDocuments && personalUpdatedDetails?.growerDocuments.filter((item) => item.documentType === "Harvest_Plan" && item.isActive == 1);
    //if (harvest.length == 0) {
    //  setErrorMessage({ harvestPlanDocError: "Please upload other document" });
    //  setExpandedSection("agreement");
    //  return;
    //}
    showPreview();
  }

  const showPreview = () => {
    if (userRole !== ROLES.ItAdmin) {
      const filteredLandComments = comments.filter((item) => item.sectionName === "land_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)
      let mandatoryFeildsCommentNotEntered = false;
      let latLonNotEntered = false
      memberDetailArray.forEach(memberItem => {
        memberItem.growerCoopLandDetails.forEach(land => {
          const landId = land.id;
          const isMandatory = shouldActOnSectionLand[landId];
          const latLonMandate = localStorage.getItem('role') === ROLES.RegistrationScruitnizer && stakeHolderDetails?.currentOwnerID === uuid
          let landPic = land?.growerCoopLandDocuments && land?.growerCoopLandDocuments.filter((item) => item.documentType === "LandPics" && (item.isActive === 1 || item.isActive === 3))
          if (latLonMandate && (!land?.geocodeLattitude || !land?.geocodeLongitude || landPic?.length === 0)) {
            latLonNotEntered = true;
            return;
          }
          else if (showCommentSection) {
            if (stakeHolderDetails?.scrutinyStatus == "Submited_Clarification") {
              if (comments.find((item) => item.sectionId === landId && item.scrutinyAction === "Submited_Clarification" && item.isActive === 1) && !filteredLandComments.some(comment => comment.sectionId === landId)) {
                mandatoryFeildsCommentNotEntered = true
                setExpandedSection("member");
                setErrorMessage({ ...errorMessage, landCommentError: "Please add comment for land" });
                return;
              }
            }
            else {
              if (isMandatory && !filteredLandComments.some(comment => comment.sectionId === landId)) {
                mandatoryFeildsCommentNotEntered = true
                setExpandedSection("member");
                setErrorMessage({ ...errorMessage, landCommentError: "Please add comment for required lands" });
                return;
              }
            }
          }
        });
      });
      if (memberDetailArray?.length === 0) {
        setErrorMessage({ ...errorMessage, memberlandDetailsError: "Please add atleast one member" });
        toast.error("Please add atleast one member");
        setExpandedSection("member");
        return;
      }
      var landPresent = true;
      memberDetailArray.forEach((item) => {
        if (item.isActive == 1 && item.growerCoopLandDetails?.length === 0) {
          landPresent = false;
        }
      });
      if (!landPresent) {
        setErrorMessage({ ...errorMessage, memberlandDetailsError: "Please add atleast one land for each member" })
        toast.error("Please add atleast one land for each member");
        setExpandedSection("member");
        return;
      }
      if (latLonNotEntered) {
        setExpandedSection("member");
        setErrorMessage({ ...errorMessage, landCommentError: "Please enter latitude and longitude and upload land pic for all lands" });
        toast.error("Please enter latitude and longitude and upload land pic for all lands");
        return;
      }
      if (showCommentSection && (noCommentForMandatorySections() || mandatoryFeildsCommentNotEntered)) {
        toast.error("Please enter comments for required sections");
        return;
      }
      else {
        enableSaveSubmitButtons && !_.isEqual(finalData, initialData) ? setCallUpdateApi(true) : setCurrentPage("preview");
        setButtonAction("preview")
        setErrorMessage({ ...errorMessage, memberlandDetailsError: "" })
      }
    }
    else {
      enableSaveSubmitButtons && !_.isEqual(finalData, initialData) ? setCallUpdateApi(true) : setCurrentPage("preview");
      setButtonAction("preview")
      setErrorMessage({ ...errorMessage, memberlandDetailsError: "" })
    }
  }

  const onGoBack = () => {
    setCurrentPage("registrationDetails")
  }

  return (
    <GrowerMemberContext.Provider value={{ growerDetails, stakeHolderDetails, memberDetails, setMemberDetails, expandedSection, setExpandedSection, regScruResourceUpdate, setRegScruResourceUpdate, errorMessage, setErrorMessage, personalUpdatedDetails, setPersonalUpdatedDetails, enableFieldFunction, shouldActOnSection, setShouldActOnSection, shouldActOnSectionLand, setShouldActOnSectionLand, landUpdatedDetails, setLandUpdatedDetails, setMemberDetailArray, memberDetailArray, onAddNewMemberDetails, onEditMemberDetailsCallback, setCallUpdateApi, newLandArray, setNewLandArray, newLandComments, setNewLandComments, commentsData, setCommentsData, comments, setComments, showCommentSection, showWorkFlowButtons, showClarificationButton, enableSaveSubmitButtons, personalDetailsSectionOk, setPersonalDetailsSectionOk, bankDetailsSectionOk, setBankDetailsSectionOk, agreementDetailsSectionOk, setAgreementDetailsSectionOk, landDetailsSectionOk, setLandDetailsSectionOk, callWorkFlowApi, setButtonAction, viewOnly: state?.viewOnly, userType: state?.userType }}>
      <>
        {currentPage === "registrationDetails" && growerDetails && <Container maxWidth="xxl" >
          {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>REG20</p>}
          <Stack direction="row" alignItems="center" spacing={1} mb={3}>
            <BackButton navigate={navigate} />
            <Typography variant="h5" gutterBottom>
              {t('reg.registrationDetails')}
            </Typography>
          </Stack>
          <Grid container spacing={2}>
            <Grid item xs={4} lg={12}>
              <TextField fullW
                required
                disabled
                type="text"
                label="URN"
                value={urn || ''}
              />
              <BadgeComponent currentLength={urn?.length} maxLength={urnMaxLength} />
            </Grid>
            <MemberPersonalDetails />
            <MemberLandDetails
              bambooSpeciesRes={bambooSpeciesRes} />
          </Grid>
          <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
            {(!showWorkFlowButtons || (localStorage.getItem('role') === ROLES.RegistrationScruitnizer && stakeHolderDetails?.currentOwnerID === uuid)) &&
              <Button
                sx={{ minWidth: 100 }}
                variant="contained"
                disabled={!enableSaveSubmitButtons || state?.viewOnly}
                onClick={() => { (!_.isEqual(finalData, initialData) ? setCallUpdateApi(true) : toast.warning("No modifications to be saved")); setButtonAction("save"); }}
                startIcon={<SaveIcon />}
              >{t('preReg.save')}
              </Button>}
            <Button
              sx={{ minWidth: 100, ml: 1 }}
              variant="contained"
              onClick={() => personalDetailsValidation()}
              startIcon={<PreviewIcon />}
            >{t('preReg.preview')}</Button>
          </Box>
        </Container>}
        {currentPage === "preview" &&
          <Grid xs={12} md={12} id='divPreview'>
            <Preview urn={urn} goBack={onGoBack} bambooSpeciesRes={bambooSpeciesRes} callWorkFlowApi={callWorkFlowApi} stakeholderType="Grower" subCategory="Member" />
          </Grid>}
      </>
    </GrowerMemberContext.Provider>
  );
}
export default RegistrationMemberDetails;
export const useGrowerMemberContextData = () => useContext(GrowerMemberContext)